import { LazyLoad } from "./modules/lazy-load.min.ec984924.js";
import { Header } from "./modules/header.min.97f7d2c5.js";
import { AuthBar } from "./modules/auth-bar.min.5373301b.js";
import { ContactForm } from "./modules/contact-form.min.c7bd9a96.js";
import { Dashboard } from "./modules/dashboard.min.b78858ee.js";
import { TicketOverview } from "./modules/ticket-overview.min.ead8c157.js";
import { ResetPassword } from "./modules/reset-password.min.0031ea45.js";
import { AdminTicket } from "./modules/admin-ticket.min.f7f54fd9.js";
import { AdminUpdateTicket } from "./modules/admin-update-ticket.min.ac0dea4c.js";

let swup = null;
let deferredPrompt = null;

// Initialize page
function initPage() {
  // Initialize Swup
  swup = new Swup({
    containers: ["#swup", "#navbar", "#footer"],
  });

  // Init scroll monitor
  transitionCallback();

  // Set transition callback
  swup.hooks.on("content:replace", transitionCallback);

  // Check PWA auth on page navigation
  // Reload iubenda iframes
  swup.hooks.on("page:view", function () {
    if ($(".iubenda-embed").length > 0) {
      location.reload();
    }
  });
}

// Callback for swup content replace
function transitionCallback() {
  // Propagate HTML classes
  htmlClassPropagation();

  // Login check
  checkLogin();
  setTimeout(checkLogin, 5000);

  // Initialize lazy load
  new LazyLoad().init();

  // Initialize header
  new Header().init();

  // Initialize auth bar
  new AuthBar().init();

  // Initialize contact form with translations
  const contactFormTranslations = window.contactFormTranslations || {};
  new ContactForm(contactFormTranslations).init();

  // Initialize dashboard
  new Dashboard().init();

  // Initialize ticket overview
  new TicketOverview().init();

  // Initialize reset password
  new ResetPassword().init();

  // Initialize admin ticket form with translations
  const adminTicketTranslations = window.adminTicketTranslations || {};
  new AdminTicket(adminTicketTranslations).init();

  // Initialize admin update ticket form with translations
  const adminUpdateTicketTranslations = window.adminUpdateTicketTranslations || {};
  new AdminUpdateTicket(adminUpdateTicketTranslations).init();

  // Iubenda check
  iubendaCheck();
}

function htmlClassPropagation() {
  // Copy class 'path' from main to html
  const mainClassList = document.querySelector("main").classList;

  // Remove all existing 'path' classes from html
  document.documentElement.classList.forEach((cls) => {
    if (cls.startsWith("path-")) {
      document.documentElement.classList.remove(cls);
    }
  });

  // Add current 'path' classes from main to html
  mainClassList.forEach((cls) => {
    document.documentElement.classList.add(cls);
  });
}

function checkLogin() {
  fetch("/auth/status?ts" + Date.now(), {
    method: "GET",
    credentials: "include",
    headers: {
      "X-Requested-With": "XMLHttpRequest",
      Cookie: document.cookie,
      "Cache-Control": "no-cache",
      Pragma: "no-cache",
    },
    cache: "no-store",
  })
    .then((response) => response.json())
    .then((data) => {
      if (data.authenticated) {
        // User is authenticated - hide login button
        $("#auth-bar").removeClass("login").addClass("enter");
        $(".user-dropdown").addClass("show");
      }
    })
    .catch((error) => {
      // On error, assume not authenticated
      $("#auth-bar").removeClass("login").addClass("enter");
      $(".user-dropown").removeClass("show");
    });
}

function iubendaCheck() {
  if (typeof _iub === "undefined") {
    // Iubenda is not loaded, so we can safely remove the cookie message
    $(".content-before-consent").each(function (_, el) {
      el.style.display = "none";
    });
    return;
  }

  // Remove iubenda cookie message
  setTimeout(function () {
    if (_iub.cs.consent.purposes !== undefined) {
      let purposes_iub = Object.keys(_iub.cs.consent.purposes);

      for (let i = 0; i < purposes_iub.length; i++) {
        if (_iub.cs.consent.purposes[purposes_iub[i]] == true) {
          // Hide cookie message for enabled purposes
          $(".content-before-consent-" + purposes_iub[i]).each(function (_, el) {
            el.style.display = "none";
          });

          // Send events to GTM
          switch (purposes_iub[i]) {
            case "2":
              // Attivatore Tag Manager categoria Interazioni Semplici
              dataLayer.push({
                event: "iubenda-interazioni-semplici",
              });
              break;
            case "3":
              // Attivatore Tag Manager categoria Esperienza Migliorata
              dataLayer.push({
                event: "iubenda-esperienza-migliorata",
              });
              break;
            case "4":
              // Attivatore Tag Manager categoria Misurazione
              dataLayer.push({ event: "iubenda-misurazione" });
              break;
            case "5":
              // Attivatore Tag Manager categoria Pubblicità
              dataLayer.push({ event: "iubenda-pubblicita" });
              break;
          }
        } else {
          // Show cookie message for disabled purposes
          $(".content-before-consent-" + purposes_iub[i]).each(function (_, el) {
            el.style.display = "flex";
          });
        }
      }
    } else {
      // Show cookie message for disabled purposes
      $(".content-before-consent").each(function (_, el) {
        el.style.display = "block";
      });
    }
    _iub.cs.api.activateSnippets();
  }, 500);
}

// PWA Functions
function initPWA() {
  // Check PWA support
  if (!("serviceWorker" in navigator)) {
    return;
  }

  // Register service worker
  navigator.serviceWorker.register("/sw.js").then((registration) => {
    // Function to send reset cache message
    function sendResetCacheMessage() {
      if (navigator.serviceWorker.controller) {
        navigator.serviceWorker.controller.postMessage({ type: "RESET_CACHE" });
      } else if (registration.active) {
        registration.active.postMessage({ type: "RESET_CACHE" });
      }
    }

    // Only send reset message if there was already a controlling service worker
    // Don't send it for newly installed service workers
    if (navigator.serviceWorker.controller) {
      sendResetCacheMessage();
    }
  });

  // Handle PWA install prompt
  window.addEventListener("beforeinstallprompt", (e) => {
    // Prevent the mini-infobar from appearing on mobile
    e.preventDefault();

    // Check if user has dismissed the install prompt before
    const dismissalInfo = getCookie("pwa_install_dismissed");
    if (dismissalInfo) {
      const dismissalData = JSON.parse(dismissalInfo);
      const daysSinceDismissal = (Date.now() - dismissalData.timestamp) / (1000 * 60 * 60 * 24);

      // Show again after 7 days
      if (daysSinceDismissal < 7) {
        return;
      } else {
        // Clear old dismissal cookie
        deleteCookie("pwa_install_dismissed");
      }
    }

    // Stash the event so it can be triggered later
    deferredPrompt = e;

    // Show install button or banner
    showInstallPrompt();
  });

  // Handle PWA installation
  window.addEventListener("appinstalled", (evt) => {
    hideInstallPrompt();

    // Clear the dismissal cookie since the app is now installed
    deleteCookie("pwa_install_dismissed");

    // Optional: Track installation
    if (typeof gtag !== "undefined") {
      gtag("event", "pwa_install", {
        event_category: "PWA",
        event_label: "App Installed",
      });
    }
  });
}

function showInstallPrompt() {
  // Create install button if it doesn't exist
  if (!document.getElementById("pwa-install-btn")) {
    const installBtn = document.createElement("button");
    installBtn.id = "pwa-install-btn";
    installBtn.innerHTML = `
      <span>+ Installa App</span>
      <span class="pwa-close-btn" style="
        position: absolute;
        right: 10px;
        top: 50%;
        transform: translateY(-50%);
        width: 20px;
        height: 20px;
        cursor: pointer;
        font-size: 18px;
        line-height: 20px;
        text-align: center;
        opacity: 0.8;
        transition: opacity 0.2s ease;
      ">×</span>
    `;

    installBtn.addEventListener("click", (e) => {
      // Check if close button was clicked
      if (e.target.classList.contains("pwa-close-btn")) {
        // Set cookie to remember dismissal with timestamp (expires in 30 days)
        const dismissalData = {
          dismissed: true,
          timestamp: Date.now(),
        };
        setCookie("pwa_install_dismissed", JSON.stringify(dismissalData), 30);

        // Track dismissal via close button
        if (typeof gtag !== "undefined") {
          gtag("event", "pwa_install_dismissed_close", {
            event_category: "PWA",
            event_label: "Install Dismissed via Close Button",
          });
        }
        deferredPrompt = null;
        hideInstallPrompt();
        return;
      }

      // Handle install button click
      if (deferredPrompt) {
        deferredPrompt.prompt();

        deferredPrompt.userChoice.then((choiceResult) => {
          if (choiceResult.outcome === "accepted") {
            // Track acceptance
            if (typeof gtag !== "undefined") {
              gtag("event", "pwa_install_accepted", {
                event_category: "PWA",
                event_label: "Install Accepted",
              });
            }
          } else {
            // Set cookie to remember dismissal with timestamp (expires in 30 days)
            const dismissalData = {
              dismissed: true,
              timestamp: Date.now(),
            };
            setCookie("pwa_install_dismissed", JSON.stringify(dismissalData), 30);

            // Track dismissal
            if (typeof gtag !== "undefined") {
              gtag("event", "pwa_install_dismissed", {
                event_category: "PWA",
                event_label: "Install Dismissed",
              });
            }
          }

          deferredPrompt = null;
          hideInstallPrompt();
        });
      }
    });

    document.body.appendChild(installBtn);
  }
}

function hideInstallPrompt() {
  const installBtn = document.getElementById("pwa-install-btn");
  if (installBtn) {
    installBtn.style.animation = "slideOutToTop 0.3s ease";
    setTimeout(() => {
      installBtn.remove();
    }, 300);
  }
}

// Cookie utility functions
function setCookie(name, value, days) {
  let expires = "";
  if (days) {
    const date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = "; expires=" + date.toUTCString();
  }
  document.cookie = name + "=" + (value || "") + expires + "; path=/; SameSite=Lax";
}

function getCookie(name) {
  const nameEQ = name + "=";
  const ca = document.cookie.split(";");
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === " ") c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
}

function deleteCookie(name) {
  document.cookie = name + "=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT; SameSite=Lax";
}

function removePreloader() {
  // Remove preloader
  $(".preloader").fadeOut(500, function () {
    $(this).remove();
  });
}

// Initialize page
$(function () {
  initPage();
  initPWA();
  removePreloader();
});

function gestisciBrMobile() {
  if (window.innerWidth <= 990) {
    document.querySelectorAll('p br, h1 br, h2 br, h3 br').forEach(br => {
      // Sostituisce il BR con un vero nodo di testo contenente uno spazio
      const spazio = document.createTextNode(' ');
      br.parentNode.replaceChild(spazio, br);
    });
  }
}

// Esegui al caricamento e al ridimensionamento
window.addEventListener('DOMContentLoaded', gestisciBrMobile);

